export default __webpack_public_path__ + "images/b9c1dd871b1c611ae0f2a8a9d854abaa-august_banner_tablet.webp";